import axiosInstance from "../../axios";
import { alertSuccess } from "../../utils/feedback";
import { GET_EVALUATION_LIST } from "../types/evaluationType";
import {
  requestFailed,
  requestStarted,
  requestSucceeded,
} from "./feedbackActionCreators";
import { claimOrgScopedRequest } from "./orgScopedRequest";

export const setEvaluationList = (evaluations) => ({
  type: GET_EVALUATION_LIST,
  payload: evaluations,
});

export const fetchEvaluationList = (orgaId) => {
  return async (dispatch) => {
    const isCurrent = claimOrgScopedRequest("evaluation_list");
    dispatch(requestStarted());
    // Dropped before the request leaves - see orgScopedRequest. The sidebar gates
    // on these phases, so another org's would also mis-enable navigation.
    dispatch(setEvaluationList({ phases: [] }));
    try {
      const response = await axiosInstance.get(
        `/survey/evaluation_progress/${orgaId}`
      );
      if (!isCurrent()) {
        // Superseded, but the loading counter it took on the way in still has
        // to be given back: feedbackReducer counts starts against successes and
        // the global overlay sits on the total. Returning without this leaks a
        // count the page can never get back, and it hangs until a reload.
        dispatch(requestSucceeded());
        return;
      }
      const phases = response?.data?.phases ?? [];
      const vulnSubScanStatus = response?.data?.vuln_sub_scan_status ?? "not_started";
      const vulnSubScanCancelStatus = response?.data?.vuln_sub_scan_cancel_status ?? "not_requested";
      const vulnSubScanRetryCount = Number(response?.data?.vuln_sub_scan_retry_count ?? 0);
      const riskReportStatus = response?.data?.risk_report_status ?? "not_started";
      const retryVulnSubScanAllowed = Boolean(
        response?.data?.retry_vuln_sub_scan_allowed
      );
      const cancelVulnSubScanAllowed = Boolean(
        response?.data?.cancel_vuln_sub_scan_allowed
      );
      console.log("Fetched evaluation phases (action):", phases);
      dispatch(setEvaluationList({
        phases,
        vulnSubScanStatus,
        vulnSubScanCancelStatus,
        vulnSubScanRetryCount,
        riskReportStatus,
        retryVulnSubScanAllowed,
        cancelVulnSubScanAllowed,
      }));

      dispatch(requestSucceeded());
    } catch (error) {
      if (!isCurrent()) {
        // Superseded, but the loading counter it took on the way in still has
        // to be given back: feedbackReducer counts starts against successes and
        // the global overlay sits on the total. Returning without this leaks a
        // count the page can never get back, and it hangs until a reload.
        dispatch(requestSucceeded());
        return;
      }
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const cancelVulnSubScan = (orgaId) => {
  return async (dispatch) => {
    dispatch(requestStarted());
    try {
      const response = await axiosInstance.post(
        `/survey/cancel_vuln_sub_scan/${orgaId}`,
        { confirm_cancel: true }
      );
      dispatch(requestSucceeded());
      alertSuccess(response?.data);
      return response;
    } catch (error) {
      const errData = error?.response?.data;
      dispatch(requestFailed(errData));
      throw error;
    }
  };
};

export const retryVulnSubScan = (orgaId) => {
  return async (dispatch) => {
    dispatch(requestStarted());
    try {
      const response = await axiosInstance.post(
        `/survey/retry_vuln_sub_scan/${orgaId}`,
        { confirm_retry: true }
      );
      dispatch(requestSucceeded());
      alertSuccess(response?.data);
      return response;
    } catch (error) {
      const errData = error?.response?.data;
      dispatch(requestFailed(errData));
      throw error;
    }
  };
};

export const validateEvaluationPhase = (orgaId, phase) => {
  return async (dispatch) => {
    dispatch(requestStarted());
    try {
      await axiosInstance.post(`/survey/user_validation`, {
        orga_id: Number(orgaId),
        phase_type: phase,
      });
      dispatch(requestSucceeded());
    } catch (error) {
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

const buildContinueEvaluationBody = (orgaId, phase, payloadData) => {
  const body = {
    orga_id: Number(orgaId),
    phase_type: phase,
  };

  // payload_data can be object (approve_vuln_scan), array (selected scenarios), etc.
  if (payloadData !== undefined) {
    body.payload_data = payloadData;
  }

  return body;
};

export const startEvaluationPhase = (orgaId, phase, payloadData) => {
  return async (dispatch) => {
    dispatch(requestStarted());
    try {
      const requestBody = buildContinueEvaluationBody(orgaId, phase, payloadData);
      const response = await axiosInstance.post(`/survey/continue_evaluation`, requestBody);
      dispatch(requestSucceeded());
      alertSuccess(response.data);
      return response;
    } catch (error) {
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const reclamationRequest = (payload) => {
  return async (dispatch) => {
    dispatch(requestStarted());
    try {
      await axiosInstance.post(`/survey/phase_feedback`, payload);
      dispatch(requestSucceeded());
    } catch (error) {
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const generate_report = (orgaId, data) => {
  return async (dispatch) => {
    dispatch(requestStarted());
    try {
      const requestBody = buildContinueEvaluationBody(orgaId, "risk_assesment", data);
      const response = await axiosInstance.post(`/survey/continue_evaluation`, requestBody);
      // console.log("Generate Report Response:", response);
      dispatch(requestSucceeded());
      alertSuccess(response.data);
      return response;
    } catch (error) {
      dispatch(requestFailed(error?.response?.data));
    }
  };
};
